export default __webpack_public_path__ + "a868793ff633933c2c79d5eb7c52671c.svg";